import RobotList from './RobotList.tsx'
// import RobotCreate from './RobotCreate.tsx'
import { RobotListProvider } from '@logic/contexts/Robots/RobotsListsContext.tsx'
import { AccountListProvider } from '@src/logic/contexts/Accounts/AccountsListsContext.tsx'

export default {
  list: <RobotListProvider><AccountListProvider><RobotList/></AccountListProvider></RobotListProvider>
}
